export default __webpack_public_path__ + "static/media/validasi-direktur.a64263d4.png";